import React from 'react';
import PropTypes from 'prop-types';
import { capitalizeFirstLetter } from '../../utils/stringConversion';
import currencyToSymbol from '../../utils/currencyToSymbol';
import getPlanPrice from '../../utils/getPlanPrice';
import CheckboxInput from '../Global/Forms/CheckboxInput';
import Button from '../Global/Buttons/Button';

const SignupSummary = ({ signup, stripe, values, onChange, acceptedTerms, onAcceptTermsChange, onChangePageClick, isSubmitting }) => {
  const paragraphClass = 'm-b-0';
  const labelClass = 'fw-medium';

  const currencySymbol = currencyToSymbol(signup.currency);
  const frequency = values.billingFrequency;
  const priceAsNumber = getPlanPrice(values.planType, frequency, signup.currency);
  const fullPrice = `${currencySymbol}${priceAsNumber} / ${frequency}`;
  const discountedPrice = priceAsNumber - ((priceAsNumber / 100) * stripe.discount.percent_off);
  const finishButtonText = values.planType !== 'basic' ? 'Proceed to Payment' : 'Create Account';
  const calculateFinalPrice = () => {
    if (stripe.discount.exists === true && values.planType !== 'basic') {
      return `${currencySymbol}${discountedPrice.toFixed(2)}`;
    }
    return `${currencySymbol}${priceAsNumber}`;
  };

  return (
    <div className="signup-summary">
      <div className="row">
        <div className="col-lg-6">
          <h3 className="like-h3 m-b-3">Summary</h3>
          <fieldset className="m-b-5 p-b-3">
            <div className="row">
              <div className="col-sm-6">
                <h4 className="like-h5 fw-medium">Plan</h4>
                <p className={paragraphClass}><span className={labelClass}>Type:</span> {capitalizeFirstLetter(values.planType)}</p>
                <p className={paragraphClass}><span className={labelClass}>Billing cycle:</span> Per {frequency}</p>
                <p className={paragraphClass}><span className={labelClass}>Price:</span> {fullPrice} {stripe.discount.exists === true && values.planType !== 'basic' && '(prior to discount)'}</p>
                <button className="btn-link" onClick={() => onChangePageClick(1)}>Edit</button>
              </div>
              
              <div className="col-sm-6 signup-summary__right-values">
                <h4 className="like-h5 fw-medium">Your Details</h4>
                <p className={paragraphClass}><span className={labelClass}>Name:</span> {values.firstName} {values.lastName}</p>
                <p className={paragraphClass}><span className={labelClass}>Email address:</span> {values.emailAddress}</p>
                <p className={paragraphClass}><span className={labelClass}>Primary role:</span> {values.isCoach ? 'Coach' : 'Player' }</p>
                <button className="btn-link" onClick={() => onChangePageClick(2)}>Edit</button>
              </div>

              <div className="col-sm-6">
                <h4 className="like-h5 fw-medium m-t-5">Account security</h4>
                <p className={paragraphClass}><span className={labelClass}>Phone number:</span> {values.areaCode1} {values.telNo1}</p>
                <button className="btn-link" onClick={() => onChangePageClick(2)}>Edit</button>
              </div>
            </div>
          </fieldset>
        </div>

        <div className="col-lg-6">
          <h3 className="like-h3 m-b-3">Review and accept</h3>
          <fieldset className="m-b-5">
            <p className="like-h4 fw-medium m-b-0">Total to pay today</p>
            <p className="like-h2 color-green fw-medium m-b-5">{calculateFinalPrice()}</p>
            <p className="color-grey m-b-5">The Coaching Manual does not store card or address details. These details are securely stored by our payment provider, Stripe. Your payment will create a subscription which will automatically renew at the end of the term you have selected. However, you can change or cancel your subscription at any point.</p>

            <div className="m-b-3">
              <CheckboxInput
                name="newsletters"
                label="If you wish to receive information about how to use The Coaching Manual as well as news about new content and features, please check this box."
                value="newsletters"
                checked={values.newsletters}
                onChange={onChange}
              />
            </div>

            <div className="m-b-3">
              <CheckboxInput
                name="acceptTerms"
                label='By signing up you agree to our <a href="https://thecoachingmanual.com/terms" target="_blank">terms</a>.'
                value="acceptTerms"
                checked={acceptedTerms}
                onChange={onAcceptTermsChange}
              />
            </div>

            {/* Google invisible reCAPTCHA markup https://developers.google.com/recaptcha/docs/invisible#example */}
            <div id="reCaptcha" />
            <Button type="submit" size="l" classes="w-100 m-b-3" loading={isSubmitting}>{finishButtonText}</Button>
          </fieldset>
        </div>
      </div>
    </div>
  );
};

SignupSummary.propTypes = {
  signup: PropTypes.object.isRequired,
  stripe: PropTypes.object.isRequired,
  values: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  acceptedTerms: PropTypes.bool.isRequired,
  onAcceptTermsChange: PropTypes.func.isRequired,
  onChangePageClick: PropTypes.func.isRequired,
  isSubmitting: PropTypes.bool.isRequired,
};

export default SignupSummary;



// WEBPACK FOOTER //
// ./library/app/components/Signup/SignupSummary.js